import AmbientEffects from 'components/desktop/AmbientEffects';
import TableSurface from 'components/TableSurface';
import TableCenterHub from 'components/desktop/TableCenterHub';
import DistributorTray from 'components/DistributorTray';

export default function TableAssetPreview() {
  return (
    <div className="tp-desktop-root fixed inset-0 flex flex-col items-center justify-center overflow-hidden">
      <AmbientEffects />
      <p className="relative z-10 mb-2 font-display text-[10px] uppercase tracking-[0.4em] text-tp-gold/70">
        5 seats + distributor
      </p>
      <div className="tp-table-perspective w-full max-w-[1240px] px-2">
        <div className="tp-table-tilt">
          <div className="tp-table-stage relative z-10">
            <TableSurface showSeatGuides previewMode liveMode={false} useBakedTexture />
            <DistributorTray />
            <TableCenterHub potAmount={850} phase="betting" />
          </div>
        </div>
      </div>
    </div>
  );
}
